import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';
const CategoryIcon = props => (
  <SvgIcon {...props} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 130 80">
    <svg>
      <path fill="#000" fillOpacity={0.12} d="M7.425 36h115.421v1H7.425z" />
      <rect
        opacity={0.4}
        x={8.033}
        y={9}
        width={48.598}
        height={16}
        rx={8}
        fill="#2962FF"
        fillOpacity={0.3}
      />
      <rect
        opacity={0.4}
        x={7.561}
        y={49}
        width={12}
        height={8}
        rx={4}
        fill="#2962FF"
        fillOpacity={0.3}
      />
      <rect
        opacity={0.4}
        x={7.561}
        y={64}
        width={12}
        height={8}
        rx={4}
        fill="#2962FF"
        fillOpacity={0.3}
      />
      <rect
        opacity={0.4}
        x={26.183}
        y={49}
        width={65.608}
        height={8}
        rx={4}
        fill="#2962FF"
        fillOpacity={0.3}
      />
      <rect
        opacity={0.4}
        x={26.183}
        y={64}
        width={50.421}
        height={8}
        rx={4}
        fill="#2962FF"
        fillOpacity={0.3}
      />
    </svg>
  </SvgIcon>
);

export default CategoryIcon;
